<script>
import FiltersPanel from "@/components/filters/FiltersPanel.vue";

export default {
    name: 'TokenTransactionsFilterPanel',
    components: { FiltersPanel },
    emits: ['change'],
    props: ['companies'],
    computed: {
        filtersDef() {
            return [
                {
                    key: 'sender',
                    label: this.$t('token_transactions.fields.sender.name'),
                    type: 'text'
                },
                {
                    key: 'receiver',
                    label: this.$t('token_transactions.fields.receiver.name'),
                    type: 'text'
                },
                ...(this.$auth.isAdmin() ? [{
                    key: 'company_id',
                    label: this.$t('users.fields.company.name'),
                    type: 'select',
                    options: this.companies ? this.companies.map(company => ({
                        label: company.name,
                        value: company.id
                    })) : []
                }] : []),
                {
                    key: 'type',
                    label: this.$t('token_transactions.fields.type.name'),
                    type: 'select',
                    options: [
                        {
                            label: this.$t('token_transactions.transaction_types.token_transfer'),
                            value: 'transfer'
                        },
                        {
                            label: this.$t('token_transactions.transaction_types.training_payment'),
                            value: 'training_payment'
                        },
                        {
                            label: this.$t('token_transactions.transaction_types.withdrawal'),
                            value: 'withdrawal'
                        }
                    ]
                },
                {
                    key: 'money_transfer_status',
                    label: this.$t('token_transactions.fields.money_transfer_status.name'),
                    type: 'select',
                    options: [
                        {
                            label: this.$t('token_transactions.money_transfer_statuses.pending'),
                            value: 'pending'
                        },
                        {
                            label: this.$t('token_transactions.money_transfer_statuses.settled'),
                            value: 'settled'
                        },
                    ]
                },
                {
                    key: 'created_at',
                    label: this.$t('token_transactions.fields.created_at.name'),
                    type: 'date'
                },
                {
                    key: 'amount',
                    label: this.$t('token_transactions.fields.amount.name'),
                    type: 'number'
                },
                {
                    key: 'value',
                    label: this.$t('token_transactions.fields.value.name'),
                    type: 'number'
                },
                {
                    key: 'currency',
                    label: this.$t('token_transactions.fields.currency.name'),
                    type: 'text'
                },
                {
                    key: 'comments',
                    label: this.$t('token_transactions.fields.comments.name'),
                    type: 'text'
                },
            ]
        }
    }
}
</script>
<template>
    <FiltersPanel
        :filters="filtersDef"
        @update:activeFilters="$emit('change', $event)"
    >
        <template #buttons>
            <slot name="buttons"/>
        </template>
    </FiltersPanel>
</template>
